export default "__VITE_ASSET__DoMXLzOu__"